const colors = {
    white: '#fff',
    black: '#000',
    transparent: 'transparent',
    bright: {
        midnight: '#2a3449',
        fog: '#5e8e85',
        mist: '#78aba7',
        hazmat: '#deffae',
        ghost: '#e9ebea',
    },
    dark: {
        midnight: '#0d192b',
        fog: '#4e5873',
        mist: '#446664',
        hazmat: '#7c8252',
        ghost: '#878b8c',
    },
    light: {
        midnight: '#aeadb6',
        fog: '#cbd5d2',
        mist: '#d5e1e1',
        hazmat: '#f1f2df',
        ghost: '#f8f8f8',
    },
    muted: {
        midnight: '#111f35',
        fog: '#7c837e',
        mist: '#98a09c',
        hazmat: '#c5c1a9',
        ghost: '#e9f1f7',
    },
    vibrant: {
        midnight: '#005fa3',
        fog: '#8dd4ce',
        mist: '#a7d5f7',
        hazmat: '#DFFF00',
        ghost: '#F9F9F9',
    },
};

export default colors;
